import { createTheme } from "@mui/material";
import { ThemeProvider } from "@mui/system";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker as MUIDatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import React from "react";

const theme = createTheme({
  components: {
    MuiStack: {
      styleOverrides: {
        root: {
          display: "contents",
          paddingTop: "0 !important",
          "> .MuiTextField-root": {
            minWidth: "0 !important",
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: ({ ownerState, theme }) => {
          return {
            backgroundColor: "transparent !important",
            height: 32,
            borderTopRightRadius: 4,
            borderTopLeftRadius: 4,
            borderBottomRightRadius: 4,
            borderBottomLeftRadius: 4,
            "& .MuiInputLabel-root": {
              color: "black",
              top: -10,
              "&.MuiInputLabel-shrink": {
                background: "rgba(255, 255, 255, 1)",
                fontWeight: 700,
                lineHeight: "0.8em",
                letterSpacing: "0.06em",
                fontSize: 15,
                top: 0,
                padding: "2px 5px",
                left: -5,
                "&.Mui-error": {
                  color: "#d32f2f",
                },
                textOverflow: "ellipsis",
              },
            },
            "& .MuiOutlinedInput-root": {
              "::-webkit-scrollbar": {
                display: "none",
              },
              height: 32,
              maxHeight: "none",
              overflowX: "hidden",
              overflowY: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              background: "white",
              border: "none",
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
              "&.Mui-error .MuiOutlinedInput-notchedOutline": {
                border: "1px solid #d32f2f",
              },
              "&.Mui-focused": {
                background: "#fdeba4",
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
                "&.Mui-error .MuiOutlinedInput-notchedOutline": {
                  border: "1px solid #d32f2f",
                },
              },
            },
            ".Mui-focused": {
              background: "#fdeba4",
            },
          };
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        root: {
          padding: "0 0 0 5px",
          "::after": {
            border: "none !important",
          },
          "::before": {
            border: "none !important",
          },
          "&.Mui-focused": {
            // background: "#fdeba4",
          },
          "&.Mui-error": {
            borderBottom: "1px solid #d32f2f",
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: ({ ownerState }) => {
          return {
            border: ownerState.error
              ? "none !important"
              : "1px solid black !important",
            borderBottom: ownerState.error
              ? "none !important"
              : "1px solid black !important",
          };
          // padding: "0 0 0 5px",
        },
        input: {
          padding: "0 4px", //QA feedback
          "::placeholder": {
            color: "#020002", //QA feedback
            fontSize: 15, //QA feedback
            fontWeight: 700, //QA feedback
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          padding: 0, //QA feedback
          color: "#020202",
          fontWeight: "bold",
          "&.Mui-focused": {
            color: "black",
          },
          fontSize: 14,
          "& .MuiInputLabel-asterisk": {
            color: "red",
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          margin: 0,
          lineHeight: 1,
          fontWeight: 700,
          height: 13,
          padding: "0 14px",
          overflow: "hidden",
        },
      },
    },
  },
});

const DatePicker = (props) => {
  const {
    inputRef,
    label,
    format = "DD/MM/YYYY",
    disableFuture = false,
    disablePast = false,
    value,
    error = false,
    required = false,
  } = props;

  // Note : Up/Down markers will not work.

  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DemoContainer components={["DatePicker"]}>
          <MUIDatePicker
            inputRef={inputRef}
            value={value}
            label={label}
            format={format}
            disableFuture={disableFuture}
            disablePast={disablePast}
            onChange={(value, validationError) => {
              props?.onChange && props?.onChange(value, validationError);
              return;
            }}
            {...props}
            slotProps={{
              textField: {
                id: props.id,
                error: error,
                required: required,
                inputProps: {
                  ...props?.inputProps,
                  className: "pp-date-picker",
                },
                onFocus: props.onFocus && props.onFocus,
                onBlur: props.onBlur && props.onBlur,
              },
            }}
          />
        </DemoContainer>
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export default DatePicker;
